// extracted by mini-css-extract-plugin
export default {"hualianBeer":"index_hualianBeer_N3ffD","header":"index_header_q7qkH","areaReports":"index_areaReports_0UdKS","navBar":"index_navBar_nW7Gr","scene":"index_scene_ezXQI"};